module.exports = __webpack_public_path__ + "static/fonts/fontello.068ca2b3.ttf";